import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.812 23C10 23 10 15 10 15H7l4.979-4L17 15h-3s-.812 6.094 3.812 8m1.667-14.908C19.267 4.141 16.006 1 12 1S4.733 4.141 4.521 8.092A5.499 5.499 0 0 0 5.5 19h3.302a12.3 12.3 0 0 1-.578-2H5.5C3.57 17 2 15.43 2 13.5c0-2.797 2.479-3.833 4.433-3.72C6.266 5.562 8.641 3 12 3c3.453 0 5.891 2.797 5.567 6.78C19.312 9.734 22 10.531 22 13.5c0 1.93-1.57 3.5-3.5 3.5h-2.518c.062.62.21 1.329.499 2H18.5a5.499 5.499 0 0 0 .979-10.908"
    }, null, -1)
  ]))]))
}
export default { render: render }